<template>
  <VanPopup
    v-model:show="modalStore.showPowerNotEnoughModal"
    class="w-[300px]"
    closeable
    position="center"
    round
    ref="body"
  >
    <div
      class="flex flex-col justify-center items-center gap-4 py-5 px-4 text-center"
    >
      <div class="flex items-center gap-1 font-bold">
        <span>{{ $t(`purchase.miss.name`) }}</span>
        <PowerIcon class="icon-lg" />
        <span class="text-base">{{ fixNumber(missPowerAmount) }}</span>
      </div>
      <span
        class="flex items-center gap-1"
        v-html="
          $t(`purchase.miss.power`, {
            crystal: fixNumber(shouldBuyCount),
            power: fixNumber(shouldBuyCount * CUBE_NUM_PER_TICKET),
          })
        "
      />

      <div class="grid grid-cols-2 gap-4">
        <button class="btn btn-outline" @click="clickBuyMore">
          {{ t(`purchase.miss.other`) }}
        </button>
        <button class="btn btn-primary" @click="clickPayCrystal">
          <CrystalIcon class="icon-xl" />
          <span>{{ shouldBuyCount }}</span>
        </button>
      </div>
    </div>
  </VanPopup>
</template>
<script lang="ts" setup>
import { ApiPostCrystalTransactionBuyPower } from "@/apis/crystal";
import { useGlobalUser } from "@/stores/globalUser";
import { useGlobalModal } from "@/stores/globalModal";
import { showFailToast, showLoadingToast, showSuccessToast } from "vant";
import { computed, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { CUBE_NUM_PER_TICKET } from "@/modules/constant";
import { fixNumber } from "@/components/Mission/MissionStat";

const userStore = useGlobalUser();
const modalStore = useGlobalModal();

const router = useRouter();

const missPowerAmount = computed(() => {
  return modalStore.spentPowerAmount - userStore.user.powerAmount;
});

const shouldBuyCount = computed(() =>
  Math.ceil(missPowerAmount.value / CUBE_NUM_PER_TICKET)
);

watch(
  () => missPowerAmount.value,
  (val) => {
    if (val <= 0 && modalStore.showPowerNotEnoughModal) {
      if (modalStore.paidPowerCallback) {
        modalStore.paidPowerCallback?.();
        modalStore.paidPowerCallback = null;
      }
      modalStore.showPowerNotEnoughModal = false;
    }
  }
);

const { t } = useI18n();

const clickBuyMore = () => {
  router.push(`/crystal#2`);
  modalStore.showPowerNotEnoughModal = false;
};

const clickPayCrystal = async () => {
  if (userStore.user.crystalQuantity < shouldBuyCount.value) {
    showFailToast(t("Message.notEnoughCrystal"));
    await router.push(`/crystal#1`);
    modalStore.showPowerNotEnoughModal = false;
  } else {
    const loading = showLoadingToast(t("Message.swapping"));
    try {
      await ApiPostCrystalTransactionBuyPower(shouldBuyCount.value);
      await userStore.updateCurrentMateId();
      loading.close();

      showSuccessToast(t("Message.exchangeSuccess"));
    } catch (e) {
      // ignore
      loading.close();
    }
  }
};

onMounted(() => {});
</script>
